export class UtilValidation {
    static getValidatorObj(dataFields) {
        const validationObj = {};
        if (UtilValidation.hasValue(dataFields) && dataFields.fieldValidator &&
            dataFields.fieldValidator.validationFunc && dataFields.fieldValidator.validationMsg) {
            // disable warning about use of Function. This is because using dynamically loaded code isn't seen as a good thing.
            // we're doing it to load the code from the template but wouldn't do it for normal file scripts
            /* jshint -W054 */
            validationObj.validationFunc = new Function('value', dataFields.fieldValidator.validationFunc);
            /* jshint +W054 */
            validationObj.validationMsg = dataFields.fieldValidator.validationMsg;
            validationObj.name = dataFields.fieldValidator.name;
        }
        return validationObj;
    }
    static hasValidateFunc(field) {
        const validateObj = UtilValidation.getValidatorObj(field);
        return validateObj.validationFunc ? true : false;
    }
    static validateFieldValue(field) {
        let res = false;
        const validateObj = UtilValidation.getValidatorObj(field);
        if (validateObj.validationFunc && field.fieldValue) {
            const validatorFunc = validateObj.validationFunc;
            res = validatorFunc(field.fieldValue);
        }
        return res;
    }
    /*
     * Validate field value, if the validation get errors, the validator name will be returned. Otherwise, return null.
     */
    static validateField(validator, newValue) {
        let res = true;
        if (validator.validationFunc) {
            const validatorFunc = validator.validationFunc;
            res = validatorFunc(newValue);
        }
        return res === false ? validator.name : null;
    }
    static hasValue(val) {
        return val !== null && typeof (val) !== 'undefined' && val !== '';
    }
    static validateMinLength(val, minLength) {
        return UtilValidation.hasValue(val) && val.length >= minLength;
    }
    static validateMaxLength(val, maxLength) {
        return !val || UtilValidation.hasValue(val) && val.length <= maxLength;
    }
}
